import { HTMLAttributes, useRef } from "react"
import styles from "./styles.module.scss"
import classNames from "classnames/bind"
import ClientOnlyPortal from "../ClientOnlyPortal"
const cn = classNames.bind(styles)

export interface IProps extends HTMLAttributes<HTMLDivElement> {
  visible: boolean
  maskClosable?: boolean
  destroyOnClose?: boolean
  maskBackgroundColor?: string
  onClose?: () => void
}

const InitModalInstance: React.FC<IProps> = ({
  visible,
  maskClosable = true,
  destroyOnClose = false,
  maskBackgroundColor,
  onClose,
  className,
  children,
}) => {
  const divRef = useRef<HTMLDivElement>()
  if (!divRef.current) {
    const div = document.createElement("div")
    divRef.current = div
    document.body.appendChild(div)
  }
  return (
    <ClientOnlyPortal>
      <div
        className={cn(styles.eufyModalContainer, className, {
          visible,
        })}
        style={{
          backgroundColor: visible ? maskBackgroundColor : "transparent",
        }}
        onClick={() => maskClosable && onClose && onClose()}
      >
        {destroyOnClose && !visible ? null : children}
      </div>
    </ClientOnlyPortal>
  )
}
const Modal: React.FC<IProps> = (props) => {
  if (typeof window === "undefined") {
    return null
  }
  return InitModalInstance(props)
}

export default Modal
